import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { postsSelectorWithList, getPosts } from '../../ducks/posts';
import { userSelector } from '../../ducks/users';
import { connect } from 'react-redux';
import get from 'lodash/get'
import times from 'lodash/times'
import PageList from '../../components/organism/page-list';
import CssIcon from "../../components/atom/CssIcon";
import RedaktionenImg from '../../assets/content/redaktionellt.png';
import PageListLoader from '../../components/organism/page-list/Loader';

const mapStateToProps = (store, { match: { params } }) => {
  const page = get(params, 'page', undefined);
  return {
    me: !!store.users.me,
    posts: postsSelectorWithList(store, 'texts', page),
    profile: userSelector(store, get(store, ['users', 'me'])),
  };
};

class Redaktionellt extends Component {
  constructor(props) {
    super(props);

    this.events = {
      handleFilter: this._handleFilter.bind(this),
    };

    this.state = {
      options: {
        // types: all, update, opinion, review, conversation
        type: 'all',
        // sorts: date, title
        sort: 'date',
      },
      isLoading: false,
    };
  }

  _handleFilter(target) {
    const { dispatch, match } = this.props;
    const page = get(match, ['params', 'page'], undefined);
    const type = target.getAttribute('type');
    const sort = target.getAttribute('sort');

    this.setState({ isLoading: true })

    let options;
    if (type) {
      options = { ...this.state.options, type: type }
      this.setState({ options }, () => dispatch(getPosts('texts', page, options)).then(afterPostLoaded));
    } else {
      options = { ...this.state.options, sort: sort }
      this.setState({ options }, () => dispatch(getPosts('texts', page, options)).then(afterPostLoaded));
    }

    const afterPostLoaded = () => {
      this.props.history.push('/redaktionellt/1')
      this.setState({ isLoading: false })
    }
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    const { options } = this.state;
    const page = get(match, ['params', 'page'], undefined);
    dispatch(getPosts('texts', page, options));
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { options } = this.state;
    if (
      get(this.props.match, ['params', 'page']) !==
      get(nextProps.match, ['params', 'page'])
    ) {
      const page = get(nextProps.match, ['params', 'page'], undefined);
      this.props.dispatch(getPosts('texts', page, options));
    }
  }

  filterMaker(filter, key) {
    const activeClass = this.state.options[filter.attr] == filter.type ? 'active' : '';

    return (
      <div
        className={'Sort-pill ' + (activeClass)}
        {...(filter.attr == 'sort'
          ? { sort: filter.type }
          : { type: filter.type })}
        onClick={event => this._handleFilter(event.target)}
        key={key}
      >
        {filter.title}
      </div>
    );
  }

  renderPageList() {
    if (this.state.isLoading) {
      let loader = [];
      times(15, (i) => {loader.push(<PageListLoader key={i} />)});
      return (
        <>
          <div className="Page-list-paging"><span>NÄSTA</span></div>
          {loader}
        </>
      );
    } 

    return (
      <PageList
        {...this.props}
        whatCategory="texts"
        pagePath="redaktionellt"
        hideSubmitPost
      />
    );
  }

  render() {
    const filters = [
      { title: 'ALLA', attr: 'type', type: 'all' },
      { title: 'RECENSION', attr: 'type', type: 'review' },
      { title: 'ÅSIKT', attr: 'type', type: 'opinion' },
      { title: 'UPPDATERING', attr: 'type', type: 'update' },
      { title: 'POD', attr: 'type', type: 'podcast' },
      { title: 'SAMTAL', attr: 'type', type: 'conversation' },
    ];

    const sortings = [
      { title: 'DATUM', attr: 'sort', type: 'date' },
      { title: 'A TILL Ö', attr: 'sort', type: 'title' },
    ];

    const filterList = filters.map(this.filterMaker.bind(this));
    const sortingList = sortings.map(this.filterMaker.bind(this));

    return (
      <div className="Redaktionellt-page Page-list-width">
        <div className="Page-list-header">
          <h1>
            <CssIcon type="stop" color="pink" width="36" height="36" />
            Redaktionellt
          </h1>
        </div>
        <div className="Page-sorting">
          <div className="Redaktionen">
            <div className="Redaktionen-box">
              <p>
                Här hittar du alla texter skrivna av redaktionen och du kan läsa
                mer om dem om du följer länken nedan.
              </p>
              <img
                src={RedaktionenImg}
                alt="Redaktionen"
                width="76"
                height="76"
              />
              <h3>
                <Link to="/om">Läs mer om redaktionen här</Link>
              </h3>
            </div>
          </div>
          <div className="Articles">
            <h3>Artiklar</h3>
            {filterList}
          </div>
          <div className="Sort">
            <h3>Sortering</h3>
            {sortingList}
          </div>
        </div>
        { this.renderPageList() }
      </div>
    );
  }
}

export default connect(mapStateToProps)(Redaktionellt);
